import { render } from "./SiteHeader.vue?vue&type=template&id=066d5ea8&scoped=true&ts=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"

import "./SiteHeader.vue?vue&type=style&index=0&id=066d5ea8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066d5ea8"]])

export default __exports__